import { Button, Grid, TextField, Typography } from '@mui/material';
import React from 'react';
import MainCard from 'ui-component/cards/MainCard';
import SubCard from 'ui-component/cards/SubCard';

import VendorListTable from './Components/VendorList/VendorListTable';
import AddVendorForm from './Components/VendorList/AddVendorForm';
import { useState } from 'react';
import BackdropLoader from './Components/General/Loader';
import { useEffect } from 'react';
import { GetAllVendors } from 'API/VendorOnboarding/api';
import SnackBar from './Components/General/SnackBar';

const VendorList = () => {
  const [CompanyName, setCompanyName] = React.useState('');
  const [OpenAddVendorForm, setOpenAddVendorForm] = React.useState(false);
  const [Data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [VendorName, setVendorName] = useState(null);
  const [AlertMessage, setAlertMessage] = useState(null);
  const [AlertType, setAlertType] = useState('success');
  const [AlertOpen, setAlertOpen] = useState(false);
  const [Page, setPage] = React.useState(1);
  const itemsperpage = 10;

  const handlePageChange = (e) => {
    console.log(e);

    setPage((prevPage) => prevPage + 1);
  };

  const handleAlertOpen = (message, type) => {
    setAlertMessage(message);
    setAlertType(type);
    setAlertOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleVendorNameChange = (e) => {
    if (/^[a-zA-Z ]*$/.test(e.target.value)) {
      setVendorName(e.target.value);
    }
  };
  const handleCompanyNameChange = (e) => {
    if (/^[a-zA-Z0-9 ]*$/.test(e.target.value)) {
      setCompanyName(e.target.value);
    }
  };

  const handleClickOpenAddVendorForm = () => {
    setOpenAddVendorForm(true);
  };

  const handleCloseAddVendorForm = () => {
    setOpenAddVendorForm(false);
  };

  useEffect(() => {
    GetAllVendors(setData, setLoading, VendorName, CompanyName, handleAlertOpen, Page, itemsperpage);
  }, []);

  const handleSearch = () => {
    GetAllVendors(setData, setLoading, VendorName, CompanyName, handleAlertOpen, Page, itemsperpage);
  };

  const handleClear = () => {
    GetAllVendors(setData, setLoading, '', '', handleAlertOpen, Page, itemsperpage);
    setVendorName('');
    setCompanyName('');
  };

  // const handleChange = (event) => {
  //     setCompanyName(event.target.value);
  // };
  return (
    <>
      <BackdropLoader open={loading} />
      <SnackBar open={AlertOpen} message={AlertMessage} type={AlertType} handleClose={handleAlertClose} />
      <AddVendorForm open={OpenAddVendorForm} handleClose={handleCloseAddVendorForm} />
      <SubCard title="Vendor List">
        <Grid container spacing={2}>
          <Grid item xs={3}>
            <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              Vendor Name
            </Typography>
            <TextField
              id="outlined-basic"
              // label="Vendor Name"
              variant="outlined"
              fullWidth
              value={VendorName ? VendorName : ''}
              size="small"
              onChange={(e) => handleVendorNameChange(e)}
            />
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h5" marginBottom={1} sx={{ color: '#20415C' }}>
              Company Name
            </Typography>
            <TextField
              id="outlined-basic"
              // label="Company Name"
              variant="outlined"
              fullWidth
              value={CompanyName ? CompanyName : ''}
              size="small"
              onChange={(e) => handleCompanyNameChange(e)}
            />
          </Grid>
          <Grid item xs={4} display={'flex'} alignItems={'center'} mt={2.5}>
            <Button
              fullWidth
              size="small"
              variant="contained"
              sx={{
                backgroundColor: '#688B2A',
                mr: 1,
                color: '#fff',
                borderRadius: '6px',
                '&:hover': {
                  backgroundColor: '#688B3A',
                  color: '#fff'
                  // borderRadius:"10px",
                }
              }}
              color="secondary"
              onClick={handleSearch}
            >
              Search
            </Button>
            <Button
              fullWidth
              size="small"
              variant="outlined"
              sx={{
                mr: 1,
                backgroundColor: '#592375',
                color: '#FFFFFF',
                borderRadius: '6px',
                '&:hover': {
                  backgroundColor: '#592375'
                }
              }}
              color="secondary"
              onClick={handleClear}
            >
              Clear
            </Button>
            <Button
              fullWidth
              variant="contained"
              sx={{
                // width:'50%',
                backgroundColor: '#688B2A',
                color: '#fff',
                // borderRadius:"10px",
                '&:hover': {
                  backgroundColor: '#688B3A',
                  color: '#fff'
                  // borderRadius:"10px",
                }
              }}
              // size="small"
              color="success"
              onClick={() => handleClickOpenAddVendorForm()}
            >
              Add vendor
            </Button>
          </Grid>
        </Grid>
      </SubCard>

      <Grid item xs={12} mt={1}>
        <MainCard>
          <VendorListTable handleSearch={handleSearch} data={Data} handlePageChange={handlePageChange} page={Page} />
        </MainCard>
      </Grid>
    </>
  );
};

export default VendorList;
